module.exports = __webpack_public_path__ + "img/16.1c0c37c3.jpg";